import React, { useMemo, useEffect, useState } from 'react'
import { ButtonHLPure, DialogSystemGLPure, GridPure, HeaderHLPure, SimpleLoading } from '../../pures'
import { Container, Grid } from '@material-ui/core';
import './clients-dashboard-ticket.css'
import moment from 'moment';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PanelBar, PanelBarItem } from '@progress/kendo-react-layout';
import { Rating } from '@progress/kendo-react-inputs';

function ClientsDashbaordTicketView(props) {
    const {
        isLoading,
        data,
        handleBack,
    } = props;

    const { t, i18n } = useTranslation('clients-dashboard', { keyPrefix: 'ticketDetailsScreen' });
    const { t: tCommon } = useTranslation('common');
    const [dateTicket, setDateTicket] = useState()

    const total = useMemo(() => data ? data.productTransactions.reduce((accumulator, currentValue) => {
        return accumulator + parseFloat(currentValue.totalAmount)
    }, 0) : 0, [data?.productTransactions])

    const ranking = useMemo(() => {
        if (data?.rankTickets) {
            return data.rankTickets.find(r => r.userId == data.userId)
        }
    }, [data?.rankTickets])

    const TotalFooterCell = (props) => {
        if (props.field === 'amount') {
            return <td className='clientsDashboardTicketView-grid-footer' colSpan={3} role={'gridcell'}>{t("total").toUpperCase()}</td>
        }
        if (props.field === 'totalAmount') {
            return <td className='clientsDashboardTicketView-grid-footer' colSpan={1} role={'gridcell'}>${total.toFixed(2)}</td>
        }
    }

    useEffect(() => {
        moment.locale(i18n.language === 'en' ? 'en' : 'es')
        setDateTicket(moment(data?.date).utc(true).format('LLL'))
    }, [i18n.language])

    return (
        <div className='clietsDashboardTicketView'>
            <DialogSystemGLPure />
            {
                isLoading
                    ? <div className='loading'>
                        <SimpleLoading />
                    </div>
                    : data
                        ? <Container>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <HeaderHLPure title={t("title")} />
                                </Grid>

                                <Grid item xs={12}>
                                    <Grid container spacing={3} alignItems='flex-start'>
                                        <Grid item xs={12} lg={6} style={{ display: 'grid', gap: 24 }}>
                                            <PanelBar>
                                                <PanelBarItem title={t("ticketDetails")} expanded>
                                                    <p><strong>{t("branchOffice")}</strong>: {data.branchOfficeAssociated.name}</p>
                                                    <p><strong>{t("ticketNumber")}</strong>: {data.ticketNumber}</p>
                                                    <p><strong>{t("date")}</strong>: {dateTicket}</p>
                                                </PanelBarItem>
                                                <PanelBarItem title={t("clientDetails")} expanded>
                                                    <p><strong>{t("name")}</strong>: {data.user.fullName}</p>

                                                    <p><strong>{t("opinion")}</strong>:</p>
                                                    {
                                                        ranking && <p>
                                                            {ranking?.rankValue && <Rating value={ranking?.rankValue} readonly />}
                                                            <br />
                                                            {ranking?.comment || "N/D"}
                                                        </p>
                                                    }
                                                </PanelBarItem>
                                            </PanelBar>
                                        </Grid>

                                        <Grid item xs={12} lg={6}>
                                            <h4>{t("products")}</h4>
                                            <GridPure
                                                className="clientsDashboardTicketView-grid"
                                                dataGrid={data.productTransactions}
                                                skip={0}
                                                take={6}
                                                rowsItems={[
                                                    {
                                                        field: 'name',
                                                        title: t("name"),
                                                    },
                                                    {
                                                        field: 'quantity',
                                                        title: t("quantity"),
                                                        format: 'numeric',
                                                        width: 80,
                                                    },
                                                    {
                                                        field: 'amount',
                                                        title: t("price"),
                                                        format: 'currency',
                                                        width: 120,
                                                    },
                                                    {
                                                        field: 'totalAmount',
                                                        title: t("amount"),
                                                        format: 'currency',
                                                        width: 120,
                                                    }
                                                ]}
                                                footerCell={TotalFooterCell}
                                            />


                                            <div>
                                                <h4>{t("offerUsed")}</h4>
                                                {
                                                    data.offerId
                                                        ? <Link to='/offers'>
                                                            <div className='clientsDashboardTicketView-offer'>
                                                                <p className='clientsDashboardTicketView-offer-title'>{data.offer.keyIdentifier} - {data.offer.name}</p>
                                                                <p className='clientsDashboardTicketView-offer-description'>{data.offer.description}</p>
                                                            </div>
                                                        </Link>
                                                        : <p>N/D</p>
                                                }
                                            </div>

                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} style={{ display: 'flex' }} justifyContent='flex-end'>
                                    <ButtonHLPure nameBtn={tCommon("back")} outlined colorScheme="primary" onClick={handleBack} />
                                </Grid>
                            </Grid>
                        </Container>
                        : null
            }
        </div>
    )
}

export default ClientsDashbaordTicketView